<div style="margin-bottom: 8px">
  <div
    style="padding: 5px; background: lightgrey; width: 100%;"
  >
    <form
      style="display: flex; align-items: center;"
      novalidate
      [formGroup]="form"
    >
      <p style="margin: 0 0 0 13px; font-size: 16px; color: black;"
      [class.text-red]="submitted && ((address && !address.postalCode) || !address) ">
        {{ text }}
      </p>
      <div
        class="custom-form-group smaller-margin"
        style="margin: 0 0 0 1rem; display: flex; align-items: center;"
      >
        <input
          formControlName="postalCode"
          type="text"
          placeholder="{{ 'Address.PostalCode' | translate }}"
          (input)="validate()"
          class="postalcode-input"
        />
        <ion-button
          type="submit"
          style="background: whitesmoke; height: 25px; border-radius: 3px"
          (click)="beginChangeAddress()"
          [disabled]="!form.valid"
        >
          {{ "General.Search" | translate }}
        </ion-button>
      </div>
    </form>
  </div>
</div>
